import React from 'react';
import framework_image from '../../../../img/framework_img.png'

const Confirmation = (props) => {
  return (
    <div id="confirmation">
    <div className='account' /*style={{ height: 100 }}*/>
      <div className='account__wrapper'>
        <div className='account__card'  >
        <div className="col-md-6 col-sm-6 col-xs-12"> 
        <img src={framework_image} alt="Posture-signup" style={{ marginBottom: '15px', width: '25vw', minWidth: '200px', maxWidth: '340px' }}/>
        <p style={{fontSize:'14px'}}>Already have an account? <a id='signinLink' href='http://app.postured.io/login'>Login</a></p>
        </div>
        <div className="col-md-6 col-sm-6 col-xs-12" style={{textAlign: "left", marginTop: "110px"}}>
        <h3 className='formHeader' >All done!</h3>
          <h4 className='description'>Your Posture environment will be set up within 24 hours and you will receive a call from your Posture Onboarding Specialist.</h4>
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}

export default Confirmation;


// WEBPACK FOOTER //
// ./src/pages/account/register/components/confirmation.js